import { useMutation } from '@tanstack/react-query';

import { createCheckout } from '../services';

export function useCreateCheckout() {
  return useMutation({
    mutationFn: createCheckout,
  });
}
